import React, { useState, forwardRef, useEffect, useRef } from "react";
import "../enquiry/enquiry.scss";
import "react-datepicker/dist/react-datepicker.css";
import FetchData from "../../providers/dataProvider";
import { useNavigate } from "react-router-dom";
import { getStorageData } from "../../utils/Validate";
import { useCallback } from "react";
import { useLocation } from "react-router-dom";
import { CreateEntry, UpdateEntry } from "../../providers/dataProvider";
import { CheckNull, convertLocalToUTCDate } from "../../utils/Validate";
import validation from "./validation";
import { ValidateMessages } from '../../constants/ValidateConstants';
import { SuccessMessages, ErrorMessages } from "../../constants/MessageConstants";

const useForm = () => {

  const navigate = useNavigate();

  const selectCustRef = useRef(null);
  const selectProjRef = useRef();
  const { data: distributorList } = FetchData("distributor");
  const { data: projectList } = FetchData("project");
  const { data: customerList } = FetchData("Customer");
  const { data: assignedEngineerData } = FetchData("userprofile");
  const { data: countryData } = FetchData("country");
  const { data: currencyList } = FetchData("currency");

  const [currencyData, setCurrencyData] = useState([]);
  const [countryInq, setCountryInq] = useState("");
  const [allocatedToInq, setAllocatedToInq] = useState(null);
  const [currencyInq, setCurrencyInq] = useState("");
  const [assignedInqEngineer, setAssignedInqEngineer] = useState(null);
  const [distributorInq, setDistributorInq] = useState(null);

  const [filteredCustData, setFilteredCustData] = useState([]);
  const [filteredProjData, setFilteredProjData] = useState([]);
  const [customerInqName, setCustomerInqName] = useState(null);
  const [projectInqName, setProjectInqName] = useState("");

  const [docError, setDocError] = useState([]);
  const location = useLocation();

  const [values, setValues] = useState({
    inquiryRef: "",
    inquiryType: "",
    customerId: "",
    customerAddress: "",
    projectId: "",
    distributorId: "",
    salesEngineerId: "",
    customerRef: "",
    contactPerson: "",
    emailAddress: "",
    mobileNo: "",
    allocatedTo: "",
    dueDate: "",
    currencyId: 0,
    conversionRate: "0",
    additionalInfo: "",
    createdBy: localStorage.getItem("authidentity"),
    inquiryProducts: [],
  });

  const { data: productFamilyList } = FetchData("productfamily");
  const [errors, setErrors] = useState({});
  const [show, setShow] = useState(false);
  const [inquiryType, setInquiryType] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [inquiryTypes, setInquiryTypes] = useState([{ id: 1, type: 'Job In Hand' }, { id: 2, type: 'Tender' }]);
  const [showNewProj, setShowNewProj] = useState(false);
  const [showNewCust, setShowNewCust] = useState(false);
  const [errorShow, setErrorShow] = useState({ show: false, errorMessage: "" });
  const [editInquiry, setEditInquiry] = useState({ row: null, id: null });
  const [created, setCreated] = useState(false);
  const [loading, setLoading] = useState(false);
  const [createMsg, setCreateMsg] = useState(null);
  const [projectData, setProjectData] = useState([]);
  const [customerData, setCustomerData] = useState([]);
  const [distributorData, setDistributorData] = useState([]);
  const [custList, setCustList] = useState([]);
  const [newAddedCustomer, setNewAddedCustomer] = useState(null);
  const [newAddedProject, setNewAddedProject] = useState(null);

  useEffect(() => {
    if (productFamilyList?.length > 0) {
      if (!values?.id) {
        const products = productFamilyList.map((pdt) => ({
          ...pdt,
          fileName: "",
          fileObj: null,
          file: {
            productFamilyId: pdt?.id,
            attachmentUrl: "",
            productNotes: "",
          },
          checked: false,
          isActive: {
            id: "",
            status: "",
          },
        }));
        setValues({ ...values, inquiryProducts: products })
      }
    }
  }, [productFamilyList]);

  useEffect(() => {
    if (location?.state) {
      const item = location?.state;
      if (item?.id) {
        if (item?.canEdit !== true) navigate("/dashboard");
        setEditInquiry({
          id: item?.id,
          row: item?.row,
        });
      } else {
        if (item?.canAdd !== true) navigate("/dashboard");
      }
    }
  }, []);

  const handleFormChange = (e) => {
    const { name, value } = e.target;
    setValues({
      ...values,
      [name]: value,
    });
    const errors1 = validation({
      ...values,
      [name]: value
    }, allocatedToInq, assignedInqEngineer);
    setErrors({
      ...errors,
      [name]: errors1[name]
    });
  }

  const handleDueDate = (date) => {
    setValues({
      ...values,
      dueDate: date,
    });
  };

  const handleDocumentChange = (e, docId) => {
    const pdts = values?.inquiryProducts?.map((obj, ind) => {
      if (obj?.id == docId) {
        return {
          ...obj,
          fileObj: e.target.files[0],
          fileName: e.target.files[0].name,
          file: {
            ...obj?.file,
            productFamilyId: docId,
            attachmentUrl: e.target.files[0].name,
            productNotes: obj?.file?.productNotes
              ? obj?.file?.productNotes
              : "",
          },
        };
      }
      return obj;
    });
    setValues({
      ...values,
      inquiryProducts: pdts,
    });
  };

  const removeAttachedFile = (docId, index) => {
    const pdts = values?.inquiryProducts?.map((obj, ind) => {
      if (obj?.id == docId) {
        return {
          ...obj,
          fileObj: "",
          fileName: "",
          file: {
            ...obj?.file,
            productFamilyId: obj?.id,
            attachmentUrl: "",
            productNotes:
              obj?.checked && obj?.isActive?.value != ""
                ? obj?.isActive?.value
                : "",
          },
        };
      }
      return obj;
    });
    setValues({
      ...values,
      inquiryProducts: pdts,
    });
  };

  const handleNotesChange = (e, pdtId, index) => {
    const pdtCopy = [...values?.inquiryProducts];
    pdtCopy[index]["file"]["productNotes"] = e.target.value;
    setValues({
      ...values,
      inquiryProducts: pdtCopy,
    });
  };

  const handleCheckChange = (e, index) => {
    const pdtCopy = [...values?.inquiryProducts];
    pdtCopy[index]["checked"] = e.target.checked;
    if (!e.target.checked) {
      pdtCopy[index]["file"]["fileName"] = "";
      pdtCopy[index]["fileName"] = "";
      pdtCopy[index]["fileObj"] = "";
      pdtCopy[index]["file"]["attachmentUrl"] = "";
      pdtCopy[index]["file"]["productNotes"] = "";
      pdtCopy[index]["isActive"]["id"] = "";
      pdtCopy[index]["isActive"]["status"] = "";
      pdtCopy[index]["isActive"]["value"] = "";
    }
    setValues({ ...values, inquiryProducts: pdtCopy });
  };

  //Enquiry Edit
  useEffect(() => {
    if (!editInquiry?.id) return;
    const { row } = editInquiry;
    if (row && productFamilyList) {
      // const obj = inquiryTypes?.find((proj) => proj?.id === String(row?.inquiryType));
      const inqProducts = productFamilyList?.map((pdt) => {
        const pd = editInquiry?.row?.inquiryProducts?.find(
          (obj) => obj?.productFamilyId === pdt?.id
        );
        if (pd) {
          return {
            ...pdt,
            fileName: pd?.attachmentUrl,
            fileObj: null,
            file: {
              productFamilyId: pd?.productFamilyId,
              attachmentUrl: pd?.attachmentUrl,
              productNotes: pd?.productNotes,
            },
            checked: pd?.attachmentUrl || pd?.productNotes ? true : false,
            isActive: {
              id: pdt?.id,
              status: "show",
              value: pd?.productNotes,
            },
          };
        } else {
          return {
            ...pdt,
            fileName: "",
            fileObj: null,
            file: {
              productFamilyId: pdt?.id,
              attachmentUrl: "",
              productNotes: "",
            },
            checked: false,
            isActive: {
              id: "",
              status: "",
            },
          };
        }
      });
      setValues((prevValues) => ({
        ...prevValues,
        inquiryRef: row?.inquiryRef,
        inquiryType: row?.inquiryType,
        customerId: row?.customerId,
        countryId: row?.countryId,
        customerAddress: row?.customerAddress,
        projectId: row?.projectId,
        id: editInquiry?.id,
        distributorId: row?.distributorId,
        modifiedBy: row?.modifiedBy,
        salesEngineerId: row?.salesEngineerId,
        customerRef: row?.customerRef,
        contactPerson: row?.contactPerson,
        emailAddress: row?.emailAddress,
        mobileNo: row?.mobileNo,
        allocatedTo: row?.allocatedTo,
        currencyId: row?.currencyId,
        conversionRate: row?.conversionRate,
        additionalInfo: row?.additionalInfo,
        inquiryProducts: inqProducts,
        dueDate: new Date(row?.dueDate) || new Date(),
      }));
    }
  }, [editInquiry, productFamilyList]);

  const handleSubmit = (e) => {
    e.preventDefault();
    setErrors(validation(values, allocatedToInq, assignedInqEngineer));
    setIsSubmitting(true);
  };

  useEffect(() => {
    if (Object.keys(errors).length === 0 && isSubmitting) {
      let formData = { ...values };
      const dt = convertLocalToUTCDate(formData["dueDate"]);
      formData["dueDate"] = dt;
      const dd = formData["inquiryProducts"]?.filter((obj) => obj?.checked).map((ob) => ob?.file);
      formData["inquiryProducts"] = dd;
      if (CheckNull(formData?.id) !== "") {
        setLoading(true);
        UpdateEntry("inquiry", formData, setCreateMsg, SuccessMessages?.UPDATED("Enquiry"), ErrorMessages?.UPDATE_ERROR("enquiry"));
      } else {
        setLoading(true);
        CreateEntry("inquiry", formData, setCreateMsg, SuccessMessages?.CREATED("Enquiry"), ErrorMessages?.UPDATE_ERROR("enquiry")
        );
      }
    } else setIsSubmitting(false);
  }, [errors]);


  useEffect(() => {
    const errorCount = Object.values(validation(values, allocatedToInq, assignedInqEngineer)).filter(Boolean).length;
    if (errorCount === 0 && isSubmitting) {
      if (CheckNull(createMsg?.message).includes("Failed")) {
        let errorsmsg = createMsg.successData;
        setErrorShow({
          show: true,
          errorMessage: errorsmsg,
        });
        setLoading(false);
      } else if (CheckNull(createMsg?.message).includes('created') || CheckNull(createMsg?.message).includes('updated')) {
        setShow(true);
        setCreated();
        setValues({});
        setLoading(false);
      }
    }
  }, [createMsg]);

  const ErrorDoneClick = () => {
    setErrorShow({ show: false, errorMessage: "" });
    setCreateMsg(null);
  };

  const SuccessDoneClick = () => {
    setShow(false);
    setLoading(false);
    navigate("/enquiry-list");
  };

  useEffect(() => {
    const derr = [...docError];
    values?.inquiryProducts?.some((ob, index) => {
      if (
        ob?.checked &&
        ob?.fileName == "" &&
        (ob?.file?.productNotes == "" || ob?.file?.productNotes == undefined)
      )
        derr[index] = ValidateMessages?.REQUIRED("Attachment or Notes");
      else derr[index] = false;
    });
    setDocError(derr);
  }, [values?.inquiryProducts]);

  useEffect(() => {
    if (docError.includes(ValidateMessages?.REQUIRED("Attachment or Notes"))) setLoading(true);
    else setLoading(false);
  }, [docError]);

  const formatCurrencyList = (list) => {
    var te = list?.map((data, index) => ({
      label: data?.shortCode,
      value: data?.id,
    }));
    return te;
  };

  const formatCustomerList = (list) => {
    var te = list?.map((data, index) => ({
      ...data,
      label: data?.customerName,
      value: data?.id,
      type: data?.type,
    }));
    return te;
  };

  useEffect(() => {
    const getDistributorData = () => {
      if (distributorList) {
        setDistributorData(distributorList)
      }
    };
    getDistributorData();
  }, [distributorList]);


  const formatProjectList = (list) => {
    var te = list?.map((data, index) => ({
      ...data,
      label: data?.projectName,
      value: data?.id,
      ref: data?.projectCode,
    }));
    return te;
  };

  const formatDistributorOption = (item) => {
    if (!item) return null;
    return {
      ...item,
      label: item?.distributorName,
      value: item?.id,
    };
  };

  const formatCountryOption = (item) => {
    if (!item) return null;
    return {
      ...item,
      label: item?.name,
      value: item?.id,
    };
  };

  const formatCurrencyOption = (item) => {
    if (!item) return null;
    return {
      ...item,
      label: item?.shortCode,
      value: item?.id,
    };
  };

  const formatInquiryTypeOption = (item) => {
    if (!item) return null;
    return {
      ...item,
      label: item?.type,
      value: item?.id,
    };
  };

  const formatEmployeeOption = (item) => {
    if (!item) return null;
    return {
      ...item,
      label:
        item?.fullName ||
        item?.engineerName ||
        item?.employeeName ||
        item?.name ||
        `${item?.firstName ?? ""} ${item?.lastName ?? ""}`.trim(),
      value: item?.identityId,
    };
  };

  useEffect(() => {
    const getCurrencyList = () => {
      if (currencyList) {
        const list = formatCurrencyList(currencyList);
        setCurrencyData(list);
      }
    };
    getCurrencyList();
  }, [currencyList]);

  useEffect(() => {
    const getCustomerData = () => {
      if (customerList) {
        setCustList(customerList);
      }
    };
    getCustomerData();
  }, [customerList]);

  useEffect(() => {
    if (custList) {
      const list = formatCustomerList(custList);
      setCustomerData(list);
    }
  }, [custList]);

  useEffect(() => {
    if (projectList) {
      const list = formatProjectList(projectList);
      setProjectData(list);
    }
  }, [projectList]);

  useEffect(() => {
    if (!values?.id) return;

    const distributorObj = formatDistributorOption(
      distributorData?.find((item) => item?.id == values?.distributorId)
    );
    if (distributorObj) setDistributorInq(distributorObj);

    const countryObj = formatCountryOption(
      countryData?.find((item) => item?.id == values?.countryId)
    );
    if (countryObj) setCountryInq(countryObj);

    const currencyObj = formatCurrencyOption(
      currencyList?.find((item) => item?.id == values?.currencyId)
    );
    if (currencyObj) setCurrencyInq(currencyObj);

    const customerObj =
      filteredCustData?.find((item) => item?.value == values?.customerId) ||
      customerData?.find((item) => item?.id == values?.customerId);
    if (customerObj) setCustomerInqName(customerObj);

    const projectObj =
      filteredProjData?.find((item) => item?.value == values?.projectId) ||
      projectData?.find((item) => item?.id == values?.projectId);
    if (projectObj) setProjectInqName(projectObj);

    const inquiryTypeObj = formatInquiryTypeOption(
      inquiryTypes?.find((item) => item?.id == values?.inquiryType)
    );
    if (inquiryTypeObj) setInquiryType(inquiryTypeObj);

    const allocatedObj = formatEmployeeOption(
      assignedEngineerData?.find((item) => item?.identityId == values?.allocatedTo)
    );
    if (allocatedObj) setAllocatedToInq(allocatedObj);

    const engineerObj = formatEmployeeOption(
      assignedEngineerData?.find((item) => item?.identityId == values?.salesEngineerId)
    );
    if (engineerObj) setAssignedInqEngineer(engineerObj);
  }, [
    values?.id,
    values?.distributorId,
    values?.countryId,
    values?.currencyId,
    values?.customerId,
    values?.projectId,
    values?.inquiryType,
    values?.allocatedTo,
    values?.salesEngineerId,
    distributorData,
    countryData,
    currencyList,
    filteredCustData,
    filteredProjData,
    inquiryTypes,
    assignedEngineerData,
  ]);

  const handleClick = (id, status, index, value) => {
    const pdtCopy = [...values?.inquiryProducts];
    pdtCopy?.forEach((el, ind) => {
      if (ind == index) {
        el["isActive"]["id"] = id;
        el["isActive"]["status"] = status;
        el["isActive"]["value"] = value;
      } else {
        el["isActive"]["id"] = "";
        el["isActive"]["status"] = "hide";
        el["isActive"]["value"] =
          el?.file?.productNotes != "" || el?.file?.productNotes != undefined
            ? el?.file?.productNotes : ""
      }
    });
    setValues({ ...values, inquiryProducts: pdtCopy });
  };

  const handleCancel = (id, status, index, value) => {
    const pdtCopy = [...values?.inquiryProducts];
    pdtCopy[index]["isActive"]["id"] = id;
    pdtCopy[index]["isActive"]["status"] = status;
    pdtCopy[index]["isActive"]["value"] = "";
    pdtCopy[index]["file"]["productNotes"] = "";
    setValues({ ...values, inquiryProducts: pdtCopy });
  };

  const handleRedirect = () => {
    setValues({});
    navigate("/enquiry-list");
  };

  // Keep the enquiry fields aligned with the selected project's master data.
  useEffect(() => {
    if (!values?.projectId) return;

    const isUnchangedFromSavedRecord =
      values?.id && editInquiry?.row?.projectId === values?.projectId;
    if (isUnchangedFromSavedRecord) return;

    const projectObj =
      filteredProjData?.find((item) => item?.id == values?.projectId) ||
      projectData?.find((item) => item?.id == values?.projectId);

    if (!projectObj) return;

    const distributorObj = distributorData?.find(
      (item) => item?.id == projectObj?.distributorId
    );
    const countryObj = countryData?.find(
      (item) => item?.id == projectObj?.countryId || item?.id == distributorObj?.countryId
    );
    const currencyObj = currencyData?.find(
      (item) => item?.value == projectObj?.currencyId || item?.value == distributorObj?.currencyId
    );
    const customerId =
      projectObj?.clientId ||
      projectObj?.mainContractorId ||
      projectObj?.mepContractorId ||
      projectObj?.designConultantId ||
      projectObj?.supervisionConsultantId ||
      "";
    const customerObj = customerData?.find((item) => item?.id == customerId);

    setProjectInqName(projectObj);
    setDistributorInq(distributorObj ? formatDistributorOption(distributorObj) : null);
    setCountryInq(countryObj ? formatCountryOption(countryObj) : null);
    setCurrencyInq(currencyObj ? formatCurrencyOption(currencyObj) : "");
    setCustomerInqName(customerObj || null);
    setAssignedInqEngineer(null);
    setAllocatedToInq(null);

    setValues((prevValues) => ({
      ...prevValues,
      distributorId: projectObj?.distributorId || prevValues?.distributorId || "",
      countryId:
        projectObj?.countryId ||
        distributorObj?.countryId ||
        prevValues?.countryId ||
        "",
      currencyId:
        projectObj?.currencyId ||
        distributorObj?.currencyId ||
        prevValues?.currencyId ||
        0,
      conversionRate:
        projectObj?.conversionRate ??
        distributorObj?.conversionRate ??
        prevValues?.conversionRate ??
        "0",
      customerId: customerObj?.id || "",
      customerAddress: customerObj?.address || "",
      emailAddress: customerObj?.email || "",
      mobileNo: customerObj?.phone || "",
      contactPerson: customerObj?.customerContact?.[0]?.name || "",
      salesEngineerId: customerObj?.assignedEngineerId || "",
      allocatedTo: "",
    }));
  }, [
    values?.projectId,
    filteredProjData,
    projectData,
    distributorData,
    countryData,
    currencyData,
    customerData,
    editInquiry,
  ]);

  //Retrieve all customer details for the given customer ID.
  useEffect(() => {
    const custObj = filteredCustData?.find(el => el?.id === newAddedCustomer?.value);
    if (!custObj) return
    setValues({
      ...values, customerId: newAddedCustomer?.value || "",
      customerAddress: custObj?.address || "",
      emailAddress: custObj?.email || "",
      mobileNo: custObj?.phone || "",
      salesEngineerId: custObj?.assignedEngineerId || ""
    })
  }, [newAddedCustomer?.value, filteredCustData]);

  useEffect(() => {
    const projObj = filteredProjData?.find(el => el?.id === newAddedProject?.value);
    if (!projObj) return
    setValues({
      ...values, projectId: projObj?.id
    })
  }, [newAddedProject?.value, filteredProjData]);

  //Retrieve customer and project details for the given distributor ID.
  useEffect(() => {
    const userProf = getStorageData();
    const userProfId = userProf?.userCompanyId;
    if (userProf?.userType === 1) {
      const filteredCustomers = customerData?.filter(el => el?.distributorId === distributorInq?.value);
      const formattedCustomerList = formatCustomerList(filteredCustomers);
      setFilteredCustData(formattedCustomerList);

      const filteredProjects = projectData?.filter(el => el?.distributorId === distributorInq?.value);
      const formattedProjectList = formatProjectList(filteredProjects);
      setFilteredProjData(formattedProjectList);
    } else if (userProf?.userType === 2 && customerData) {
      if (!values?.id) {
        setValues((prevValues) => ({
          ...prevValues,
          distributorId: userProfId,
          countryId: distributorData?.find(item => item.id === userProfId)?.countryId,
          currencyId: distributorData?.find(item => item.id === userProfId)?.currencyId,
        }));
      }
      const filteredCustListData = customerData?.filter(el => el?.distributorId === userProfId);
      const formattedCustList = formatCustomerList(filteredCustListData);
      setFilteredCustData(formattedCustList);
      const filteredProjects = projectData?.filter(el => el?.distributorId === userProfId);
      const formattedProjectList = formatProjectList(filteredProjects);
      setFilteredProjData(formattedProjectList);
    }
  }, [distributorInq?.value, customerData, projectData, distributorData]);

  return {
    setShowNewProj,
    setShowNewCust,
    selectCustRef,
    values,
    setValues,
    distributorData,
    customerInqName,
    setCustomerInqName,
    setErrors,
    errors,
    handleDocumentChange,
    setCountryInq,
    setAllocatedToInq,
    ErrorDoneClick,
    errorShow,
    setCurrencyInq,
    setProjectInqName,
    setInquiryType,
    setAssignedInqEngineer,
    handleClick,
    setDistributorInq,
    distributorInq,
    filteredCustData,
    handleFormChange,
    countryData,
    countryInq,
    assignedEngineerData,
    allocatedToInq,
    currencyData,
    currencyInq,
    projectInqName,
    selectProjRef,
    inquiryTypes,
    inquiryType,
    handleDueDate,
    assignedInqEngineer,
    handleCheckChange,
    docError,
    removeAttachedFile,
    handleNotesChange,
    handleCancel,
    handleRedirect,
    loading,
    handleSubmit,
    currencyList,
    showNewProj,
    customerList,
    projectList,
    projectData,
    setProjectData,
    distributorList,
    setCustList,
    showNewCust,
    createMsg,
    setCreateMsg,
    setShow,
    show,
    SuccessDoneClick,
    setNewAddedCustomer,
    setNewAddedProject,
    filteredProjData
  };
};

export default useForm;